/* eslint-disable max-len, no-inline-comments */
import type {ComponentType} from 'react';

import dynamic from 'next/dynamic';

import type {Config} from 'types/payload-types';

const AboutUs = dynamic(async () => (await import(/* webpackChunkName: "AboutUs" */'./AboutUs')).AboutUs, {ssr: true});
const CardGridBlock = dynamic(async () => (await import(/* webpackChunkName: "CardGridBlock" */'./CardGridBlock')).CardGridBlock, {ssr: true});
const ContactBlock = dynamic(async () => (await import(/* webpackChunkName: "ContactBlock" */'./ContactBlock')).ContactBlock, {ssr: true});
const CtaBlock = dynamic(async () => (await import(/* webpackChunkName: "CtaBlock" */'./CtaBlock')).CtaBlock, {ssr: true});
const HeroBlock = dynamic(async () => (await import(/* webpackChunkName: "HeroBlock" */'./HeroBlock')).HeroBlock, {ssr: true});
const ImageBlock = dynamic(async () => (await import(/* webpackChunkName: "ImageBlock" */'./ImageBlock')).ImageBlock, {ssr: true});
const ImageGridBlock = dynamic(async () => (await import(/* webpackChunkName: "ImageGridBlock" */'./ImageGridBlock')).ImageGridBlock, {ssr: true});
const ImageSliderBlock = dynamic(async () => (await import(/* webpackChunkName: "ImageSliderBlock" */'./ImageSliderBlock')).ImageSliderBlock, {ssr: true});
const JobsBlock = dynamic(async () => (await import(/* webpackChunkName: "JobsBlock" */'./JobsBlock')).JobsBlock, {ssr: true});
const JobsIntroBlock = dynamic(async () => (await import(/* webpackChunkName: "JobsIntroBlock" */'./JobsIntroBlock')).JobsIntroBlock, {ssr: true});
const NewsBlock = dynamic(async () => (await import(/* webpackChunkName: "NewsBlock" */'./NewsBlock')).NewsBlock, {ssr: true});
const NewsIntroBlock = dynamic(async () => (await import(/* webpackChunkName: "NewsIntroBlock" */'./NewsIntroBlock')).NewsIntroBlock, {ssr: true});
const TextBlock = dynamic(async () => (await import(/* webpackChunkName: "TextBlock" */'./TextBlock')).TextBlock, {ssr: true});
const SequenceBlock = dynamic(async () => (await import(/* webpackChunkName: "SequenceBlock" */'./SequenceBlock')).SequenceBlock, {ssr: true});
const ListOverviewBlock = dynamic(async () => (await import(/* webpackChunkName: "ListOverviewBlock" */'./ListOverviewBlock')).ListOverviewBlock);

type BlockComponentMap = {
  [K in keyof Config['blocks']]: ComponentType<any>;
};

export const BlockMap: BlockComponentMap = {
    aboutUs: AboutUs,
    cardGrid: CardGridBlock,
    contact: ContactBlock,
    cta: CtaBlock,
    hero: HeroBlock,
    imageBlock: ImageBlock,
    imageGrid: ImageGridBlock,
    imageSlider: ImageSliderBlock,
    jobIntro: JobsIntroBlock,
    jobs: JobsBlock,
    listview: ListOverviewBlock,
    news: NewsBlock,
    newsIntro: NewsIntroBlock,
    sequence: SequenceBlock,
    'text-block': TextBlock
};

export const Application = dynamic(async () => (await import(/* webpackChunkName: "ApplicationBlock" */'./ApplicationBlock')).ApplicationBlock, {ssr: true});